/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormControlLabel = styled(FormControlLabel)({
  margin: 0,
  '& .MuiFormControlLabel-label': {
    fontFamily: '"Source Sans Pro", sans-serif',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0,
    color: '#242546',
  },
});

const CustomFormControlLabel = ({ label, control, ...props }) => (
  <StyledFormControlLabel control={control} label={label} {...props} />
);

CustomFormControlLabel.propTypes = {
  label: PropTypes.string.isRequired,
  control: PropTypes.node.isRequired,
};

export default CustomFormControlLabel;
